module.exports = __webpack_public_path__ + "static/media/ic-chevron.e529c8e3.svg";